import { sendMobileEvent } from '@lib';
import { MOBILE_ACTIONS } from 'config/constants';
import { redirectTo, ROUTES } from 'config/navigation';

import usePayload from './usePayload';

const useNavigation = () => {
  const { platform, referrerUrl } = usePayload();

  const navigateToLounge = () => {
    const isMobile = platform === 'ios' || platform === 'android';

    if (referrerUrl) {
      try {
        if (window?.top) window.top.location = referrerUrl;
      } catch {
        redirectTo(ROUTES.HOME);
      }

      return null;
    }

    if (isMobile) return sendMobileEvent(MOBILE_ACTIONS.BACK);

    redirectTo(ROUTES.HOME);
  };

  return {
    navigateToLounge,
  };
};

export default useNavigation;
